<template>
  <div
    class="sidebar"
    :class="isShelter ? 'farAway' : ''"
    v-clickoutside="closeDrawer"
  >
    <div class="sidebar-list">
      <!-- 去个人中心 -->
      <div class="sidebar-item">
        <i class="sidebar-icon" @click="toMine"></i>
        <div class="sidebar-tips">个人中心</div>
      </div>
      <!-- 购物车 -->
      <div class="sidebar-item" @click="showCartDrawer = true,showDiscountDrawer = false">
        <i class="sidebar-icon"></i>
        <span class="sidebar-item-name">购物车</span>
        <span class="sidebar-item-cart-num">{{ total }}</span>
      </div>
      <!-- 消息 -->
      <div class="sidebar-item">
        <i class="sidebar-icon"></i>
        <div class="sidebar-tips" @click="goNews">消息中心</div>
      </div>
      <!-- 优惠券 -->
      <div class="sidebar-item" @click="showDiscountDrawer = true,showCartDrawer = false">
        <i class="sidebar-icon"></i>
        <div class="sidebar-tips">优惠券</div>
      </div>
      <!-- 收藏 -->
      <div class="sidebar-item">
        <i class="sidebar-icon"></i>
        <div class="sidebar-tips" @click="goCollect">收藏</div>
      </div>
      <!-- 足迹 -->
      <div class="sidebar-item">
        <i class="sidebar-icon"></i>
        <div class="sidebar-tips" @click="goFootprint">足迹</div>
      </div>
      <!-- 联系电话 -->
      <div class="sidebar-item">
        <i class="sidebar-icon"></i>
        <div class="sidebar-tips">{{servicePhone}}</div>
      </div>
      <!-- 联系客服 -->
      <!-- <div class="sidebar-item">
        <i class="sidebar-icon"></i>
        <div class="sidebar-tips">上海琪琪</div>
      </div> -->
      <!-- APP二维码 -->
      <!-- <div class="sidebar-item">
        <i class="sidebar-icon"></i>
      </div> -->
      <!-- 回到顶部 -->
      <div class="sidebar-item" @click="backTop()">
        <i class="sidebar-icon"></i>
        <div class="sidebar-tips">回到顶部</div>
      </div>
    </div>
    <div class="sidebar-drawer" v-if="showCartDrawer">
      <div v-if="cartList.length">
        <ul class="cart-list">
          <li class="cart-item" v-for="(item, index) in cartList" :key="index">
            <dl>
              <dt class="cart-add-datetime">
                <button
                  type="button"
                  class="btnRemove"
                  @click="removeGoods($event, index)"
                >
                  移除
                </button>
              </dt>
              <dd class="cart-goods-item">
                <a :href="`goodsDetail`">
                  <img
                    class="cart-goods-pic"
                    :src="item.thumbnail"
                    alt="item.num"
                  />
                </a>
                <div class="cart-goods-main">
                  <a :href="`goodsDetail`" class="cart-goods-name">
                    {{ item.title }}
                  </a>
                  <p class="cart-goods-info">
                    <span class="cart-goods-nums"> * {{ item.num }} 件 </span>
                    <span class="cart-goods-price"
                      ><em>￥</em>{{ item.price }}</span
                    >
                  </p>
                </div>
              </dd>
            </dl>
          </li>
        </ul>
        <div class="drawer-opt">
          <div class="drawer-total">
            已选{{ total }}件，共计{{ totalPrice }}
          </div>
          <button type="button" class="btn btn-danger" @click="$.router.push('goodsCar')">去购物车</button>
        </div>
      </div>
      <div class="cart-empty" v-else>
        <img :src="'bg_discount_no.png' | imagePath" alt="" />
        <span>购物车空空的哦~，去看看心仪的商品吧~</span>
        <button
          type="button"
          class="btn btn-danger"
          @click="$.router.push('goodsList')"
        >
          去购物
        </button>
      </div>
    </div>
    <div class="sidebar-drawer" id="coupon-drawer" v-if="showDiscountDrawer">
      <div class="coupon-title" :class="active1?'active':''" @click="active1 = !active1">可领取的券({{this.couponTotal}})</div>
      <ul class="coupon-list">
        <!-- item.is_draw == 1已领取 v-show="item.is_draw !== 1"-->
        <li
          class="coupon-item"
          v-for="(item, index) in couponList"
          :key="index"
        >
          <div class="coupon-item-top">
            <div class="coupon-item-left">
              <div class="coupon-item-price" :style="{'font-size':`${0.3 / Math.ceil(((item.type == 3 ? item.discount_per : item.amount).toString().length / 4)) }rem`}">
                <span v-if="item.type == 3">
                {{ item.discount_fper }}
                  <!-- <em :style="{'font-size':`${0.3 / Math.ceil(((item.type == 3 ? item.discount_per : item.amount).toString().length / 4)) - 1 }rem`}">&nbsp;折</em> -->
                </span>
                <span v-else><em :style="{'font-size':`${0.3 / Math.ceil(((item.type == 3 ? item.discount_per : item.amount).toString().length / 4)) - 1 }rem`}">￥</em>{{item.amount}} </span>
              </div>
            </div>
            <div class="coupon-item-center">
              <p class="coupon-item-limit">
                {{
                  item.limit_amount ? `满${item.limit_amount}可用` : "无门槛"
                }}
              </p>
              <div class="coupon-item-rule">
                {{ item.use_rules }}
              </div>
            </div>
            <i></i>
            <div class="coupon-item-type">{{`${item.usable_ftype}`}}</div>
          </div>
          <div class="coupon-item-bottom">
            <div class="coupon-item-expiration-date">
              <span>{{item.validity_type == 0 ? '永久有效' : (item.validity_type == 1 ? '有效期至:'+item.end_at : '领取后'+item.validity_days+'天内有效')}}</span>
            </div>
            <div class="coupon-item-opt">
              <button type="button" @click="drawCoupon($event,index)">领取</button>
            </div>
          </div>
        </li>
      </ul>
      <cm-placeholder v-if="couponList.length == 0"></cm-placeholder>
      <div class="coupon-title"  :class="active2?'active':''" @click="active2 = !active2">可使用的券({{myCouponTotal}})</div>
      <ul class="coupon-list">
        <li
          class="coupon-item"
          :class="`status${item.status}`"
          v-for="(item, index) in myCouponList"
          :key="index"
        >
          <div class="coupon-item-top">
            <div class="coupon-item-left">
              <div class="coupon-item-price" :style="{'font-size':`${0.3 / Math.ceil(((item.type == 1 ? item.amount : item.discount_per).toString().length / 4)) }rem`}">
                <span v-if="item.type == 3">
                {{ item.discount_fper }}
                </span>
                <span v-else><em :style="{'font-size':`${0.3 / Math.ceil(((item.type == 3 ? item.discount_per : item.amount).toString().length / 4)) - 1 }rem`}">￥</em>{{item.amount}} </span>
              </div>
            </div>
            <div class="coupon-item-center">
              <p class="coupon-item-limit">
                {{
                  item.limit_amount ? `满${item.limit_amount}可用` : "无门槛"
                }}
              </p>
              <div class="coupon-item-rule">
                {{ item.use_rules }}
              </div>
            </div>
            <i></i>
            <div class="coupon-item-type">{{`${item.usable_ftype}`}}</div>
          </div>
          <div class="coupon-item-bottom">
            <div class="coupon-item-expiration-date">
              <span>{{item.is_forever == 1 ? '永久有效' : '有效期至:'+item.end_at }}</span>
            </div>
            <div class="coupon-item-opt mycoupon-item-opt">
              <a :href="'goodsList?my_coupon_id='+item.my_coupon_id | hrefFormat" target="_blank">{{item.fstatus}}</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      showCartDrawer: false,
      showDiscountDrawer: false,
      scrollTop: 0,
      active1:false,
      active2:false,
      page:1,
      limit:9999,
      status:0,
      servicePhone:this.$.storage.getItem('changwei_CUSTOMER_SERVICE_TELEPHONE')
    };
  },
  computed: {
    ...mapGetters("cart", ["total", "cartList"]),
    ...mapGetters("coupon", {"couponTotal":"total","couponList":"couponList","myCouponTotal":"myTotal","myCouponList":"myCouponList"}),
    totalPrice() {
      //购物车价格总计
      const { cartList } = this;
      let t = cartList.reduce((prev, curr) => {
        return curr.num * curr.price + prev;
      }, 0);
      return t > 0 ? this.cutZero(t.toFixed(4)) : t;
    },
    isShelter() {
      return this.scrollTop > 300;
    },
    isLogin() {
      return !!this.$.user.userToken();
    }
  },
  methods: {
    getCartList() {
      this.$store.dispatch("cart/GetCartList");
    },
    getCouponList() {
      //获取优惠券列表
      const { page,limit,status } = this
      this.$store.dispatch("coupon/SetMyCouponListFilter",{ page,limit,status });
      this.$store.dispatch("coupon/GetCouponList");
    },
    getMyCouponList() {
      //获取我的优惠券列表
      this.$store.dispatch("coupon/GetMyCouponList");
    },
    removeGoods(e, index) {
      //移除商品
      const { cartList } = this;
      this.$store
        .dispatch("cart/RemoveCart", {
          cart_ids: JSON.stringify([cartList[index].cart_id]),
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("删除购物车商品成功!");
          }
        });
    },
    drawCoupon(e,index){
      const { coupon_id } = this.couponList[index]
      console.log(coupon_id)
      this.$store.dispatch("coupon/DrawCoupon", { coupon_id }).then(res=>{
        console.log(res)
        if(res.code == 200 ){
          this.$message.success("领取购物券成功!")
        }
      })
    },
    closeDrawer() {
      this.showCartDrawer = false;
      this.showDiscountDrawer = false;
    },
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    toMine() {
      const path = this.isLogin ? "account" : "login";
      this.$.router.push(path);
    },
    // 足迹
    goFootprint() {
      if(this.$.user.userLogin()){
        this.$.router.push('mineFootprint')
      } else {
        this.$.router.replace('/login',{fromUrl:'mineFootprint'})
      }
    },
    // 收藏
    goCollect() {
      if(this.$.user.userLogin()){
        this.$.router.push('mineCollect')
      } else {
        this.$.router.replace('/login',{fromUrl:'mineCollect'})
      }
    },
    // 消息
    goNews() {
      if(this.$.user.userLogin()){
        this.$.router.push('news')
      } else {
        this.$.router.replace('/login',{fromUrl:'news'})
      }
    },
    // 去小数点0
    cutZero(num) {
      var pNum = num.split('.')[0]
      num = num.split('.')[1]
      if(parseInt(num)%10 == 0){
        if(parseInt(num)%100 == 0){
          if(parseInt(num)%1000 == 0){
            num = num.slice(0,num.length-3)
          } else {
            num = num.slice(0,num.length-2)
          }
        } else {
          num = num.slice(0,num.length-1)
        }
      }
      num = pNum + '.' + num
      return num
      console.log(parseFloat(num))
    }
  },
  mounted() {
    if (this.isLogin) {
      this.getCartList();
      this.getCouponList();
      this.getMyCouponList();
    }
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
};
</script>

<style>
.sidebar {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  width: 35px;
  background-color: #383838;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.sidebar-item {
  width: 35px;
  cursor: pointer;
  margin: 10px 0;
}
.sidebar-icon {
  width: 35px;
  height: 35px;
  display: block;
  position: relative;
  z-index: 99;
  background: #383838;
}
.sidebar-item-name {
  display: block;
  width: 20px;
  margin: 0 auto;
  color: #ccc;
  text-align: center;
}
.sidebar-item:nth-child(1) .sidebar-icon {
  background: url(../../assets/images/icon_nav1.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(2) .sidebar-icon {
  background: url(../../assets/images/icon_nav2.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(2) {
  border-top: 1px solid #4d4d4d;
  border-bottom: 1px solid #4d4d4d;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sidebar-item-cart-num {
  display: inline-block;
  min-width: 17px;
  padding: 2px;
  background-color: #e23435;
  color: #fff;
  line-height: 16px;
  border-radius: 5px;
  text-align: center;
  margin: auto;
  margin-top: 10px;
}
.sidebar-item:nth-child(3) .sidebar-icon {
  background: url(../../assets/images/icon_nav3.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(4) .sidebar-icon {
  background: url(../../assets/images/icon_nav4.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(5) .sidebar-icon {
  background: url(../../assets/images/icon_nav5.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(6) .sidebar-icon {
  background: url(../../assets/images/icon_nav6.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(7) .sidebar-icon {
  background: url(../../assets/images/icon_nav7.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(8) .sidebar-icon {
  background: url(../../assets/images/icon_nav10.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(9) .sidebar-icon {
  background: url(../../assets/images/icon_nav9.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item:nth-child(10) .sidebar-icon {
  background: url(../../assets/images/icon_nav10.png) no-repeat center;
  background-size: 50%;
}
.sidebar-item {
  position: relative;
  z-index: 10;
}
.sidebar-tips {
  color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  height: 35px;
  line-height: 36px;
  white-space: nowrap;
  transform: translateX(0%);
  background: #383838;
  padding: 0 10px;
  z-index: -999;
  transition: all 0.3s ease-in-out;
  opacity: 0;
  min-width: 10px;
}
.sidebar-item:hover .sidebar-tips {
  transform: translateX(-100%);
  opacity: 1;
}
.sidebar-drawer {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 35px;
  width: 305px;
  z-index: -1;
  background: #fff;
  box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
}
.cart-list {
  overflow: hidden;
  overflow-y: scroll;
  position: absolute;
  top: 0;
  bottom: 100px;
  right: 0;
  left: 0;
}
.drawer-opt {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 20px;
}
.drawer-total {
  text-align: center;
  margin-bottom: 10px;
}
.drawer-opt button {
  margin: auto;
  width: 100%;
}
.cart-item {
  background: #fff;
  margin: 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: 1px solid #ebeef5;
}
.cart-add-datetime {
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
  color: #666;
  display: flex;
  height: 17px;
}
.cart-add-datetime .btnRemove {
  margin-left: auto;
  display: none;
  color: #e60012;
  height: 17px;
}
.cart-item:hover .cart-add-datetime .btnRemove {
  display: block;
}
.cart-goods-pic {
  width: 50px;
  height: 50px;
}
.cart-goods-item {
  display: flex;
  padding: 10px 15px;
}
.cart-goods-main {
  margin-left: 20px;
}
.cart-goods-main a {
  color: #333;
}
.cart-goods-info {
  display: flex;
  justify-content: space-between;
  margin-top: 3px;
}
.cart-goods-price {
  color: #e60012;
}
.coupon-item {
  width: 280px;
  margin: 10px auto;
  background-size: contain;
  display: flex;
  align-items: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  border-radius: 6px;
  flex-direction: column;
  box-shadow: 2px 6px 10px 2px rgba(0 0 0 / 10%);
}
.coupon-item-left {
  width: 72px;
  text-align: left;
  color: #fff;
  padding-left: 6px;
  flex-shrink: 0;
}
.coupon-item-center {
  padding-left: 20px;
  color: #fff;
  flex-grow: 1;
}
.coupon-item {
  position: relative;
}
.coupon-item-price {
  font-size: 30px;
}
.coupon-item-price + p {
  padding-left: 5px;
}
.coupon-item-price em {
  font-size: 14px;
}
.coupon-title {
  display: block;
  width: 100%;
  text-align: center;
  margin: 20px 0;
  position: relative;
  color: #e60012;
  cursor: pointer;
  user-select: none;
}
.coupon-title::before {
  content: "";
  position: absolute;
  display: block;
  left: 10px;
  top: 50%;
  width: 80px;
  height: 1px;
  background: #e60012;
  display: block;
}
.coupon-title::after {
  content: "";
  position: absolute;
  display: block;
  right: 10px;
  top: 50%;
  width: 80px;
  height: 1px;
  background: #e60012;
  display: block;
}
.cart-goods-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.cart-goods-name:hover {
  color: #e60012;
}
#coupon-drawer,
.cart-list {
  overflow: hidden;
  overflow-y: scroll;
}
#coupon-drawer:hover::-webkit-scrollbar,
.cart-list:hover::-webkit-scrollbar {
  display: block;
}
#coupon-drawer::-webkit-scrollbar,
.cart-list::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  display: none;
}
#coupon-drawer::-webkit-scrollbar-thumb,
.cart-list::-webkit-scrollbar-thumb {
  border-radius: 7px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #e8e8e8;
}
#coupon-drawer:-webkit-scrollbar-track,
.cart-list:-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rosybrown;
  border-radius: 3px;
}
.sidebar-item:nth-child(9) {
  margin-bottom: 130px;
}
.cart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 100%;
}
.cart-empty img {
  margin: 0 0 20px 0;
  width: 200px;
}
.cart-empty span {
  margin: 30px 0;
}
.sidebar.farAway,
.sidebar.farAway .sidebar-drawer {
  top: 78px;
}
.coupon-item-top {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e60012;
  padding: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 60px;
  position: relative;
  width: 260px;
}
.coupon-item-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  background: #fff;
  height: 35px;
  position: relative;
  z-index: 11;
}
.coupon-item-price span {
  color: #fff;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.coupon-item-rule {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: 5px;
}
.coupon-item-opt button,.mycoupon-item-opt a {
  border: 1px solid #e60012;
  padding: 2px 10px;
  font-size: 12px;
  border-radius: 28px;
  color: #e60012;
}
.mycoupon-item-opt a{
  display: block;
  text-align: center;
  color: seagreen;
  border: 1px solid seagreen;
}
.coupon-item-top i{
  position: absolute;
  left: -15%;
  top: 45px;
  height: 190px;
  width: 390px;
  background-color: rgba(255, 255, 255, 0.25);
  transform: rotate(-30deg);
}
.coupon-title.active+ul{
  display: none;
}
.coupon-item-type{
  display: block;
  position: absolute;
  top: 10px;
  right: -6px;
  background: #fff;
  padding: 2px 20px 2px 20px;
  font-size: 12px;
  border:1px solid #eee;
  border-left: 0;
}
.coupon-item-type::before{
  content:"";
  position: absolute;
  right: 100%;
  width: 0;
  height: 0;
  top: 0;
  left: 0;
  border-top: 10px solid #fff;
  border-bottom: 10px solid #fff;
  border-left: 10px solid transparent;
  background: rgb(236,64,77);
}
.coupon-item-type::after{
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  border-top: 5px solid #c0c4cc;
  border-right: 5px solid transparent;
  right: 0;
  bottom: -6px;
}
.coupon-item.status0 .coupon-item-top{
  background: seagreen;
}
.coupon-item.status0 .coupon-item-type::before{
  background: #62a881;
}
.coupon-item.status0 .coupon-item-opt button{
  color: seagreen;
  border: 1px solid seagreen;
}
.coupon-item.status1 .coupon-item-top{
  background: slategray;
}
.coupon-item.status1 .coupon-item-type::before{
  background: #94a0ac;
}
.coupon-item.status1 .coupon-item-opt button{
  color: slategray;
  border: 1px solid slategray;
}
</style>



// WEBPACK FOOTER //
// src/components/SideBar/index.vue